import Service, { getCallApiFunction } from '../service'
// import denormalizer from './denormalizer'
// import normalizer from './normalizer'

// Interface
export interface ISetPromotionTicket {
  couponCode: string
}

class setPromotionTicketApi extends Service {
  constructor(params: ISetPromotionTicket) {
    super()
    this.name = 'SET_PROMOTION_TICKET'

    this.config = {
      url: `/v1/promotion/ticket/claim`,
      method: 'POST',
      data: { ...params },
    }
  }
}

export const setPromotionTicket = (params: ISetPromotionTicket) => getCallApiFunction(new setPromotionTicketApi(params))
